
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ProductCategoryMstApi } from '../../api/master/productcategory-mst.api';
import { ProductCategoryMst, ProductCategoryMstData } from '../../interface/master/productcategory-mst';

@Injectable()
export class ProductCategoryMstService extends ProductCategoryMstData {

  constructor(private api: ProductCategoryMstApi) {
    super();
  }
  list(url: string): Observable<ProductCategoryMst[]> {
    return this.api.list(url);
  }
  getById(url:string): Observable<ProductCategoryMst>{
      return this.api.getById(url);
  }
  create(url: string, data:ProductCategoryMst): Observable<ProductCategoryMst> {
    return this.api.add(url,data);
  }
  update(url: string, data:ProductCategoryMst): Observable<ProductCategoryMst> {
    return this.api.update(url,data);
  }
  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
